import React from 'react';
import { motion } from 'framer-motion';
export function Agitation() {
  return <section className="w-full bg-cream-alt py-20 px-4" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-gray-100" data-id="element-19">
          <div className="prose prose-lg max-w-none" data-id="element-20">
            <p className="text-xl md:text-2xl text-gray-800 leading-relaxed mb-6" data-id="element-21">
              การเป็นอาจารย์สอนฟุตบอลในไทยตอนนี้ ไม่ใช่เรื่องง่ายอีกต่อไป
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-22">
              คุณต้องวางแผนการสอนใหม่ทุกสัปดาห์
              นักเรียนแต่ละกลุ่มมีระดับที่แตกต่างกัน
              ผู้ปกครองถามหาผลลัพธ์ที่จับต้องได้
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-23">
              คุณทำงานหนักทุกวัน แต่ยังรู้สึกว่าขาดระบบที่ชัดเจน
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-24">
              ไม่ใช่ความผิดของคุณ ไม่มีใครเคยให้ระบบที่ใช้งานได้จริงกับคุณ
            </p>
            <p className="text-2xl md:text-3xl font-display font-bold text-navy-primary text-center mt-8" data-id="element-25">
              จนกระทั่งวันนี้
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}